import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { Editor } from './reactTinymce';
import { editorConfig } from '@/components/Layout/editorConfig';
import { apiHolder as api, apis, conf as config, inWindow } from 'api';
import HOCEditorGrammar from './HOCEditorGrammar';
import HOCEditorEmoji from './HOCEditorEmoji';
import HOCAiWriteMail from './HOCAiWriteMail';
import HOCEditorPreview from './HOCEditorPreview';
import HOCToolbarTip from './HOCToolbarTip';
import HOCCaptureScreen from './HOCCaptureScreen';
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const performanceApi = api.api.requireLogicalApi(apis.performanceImpl);
const systemApi = api.api.getSystemApi();
const inEdm = systemApi.inEdm();
const isElectron = systemApi.isElectron();
const contextPath = config('contextPath');
const env = process.env.NODE_ENV;
const isProd = config('stage') === 'prod';
let siriusVersion = '';
if (inWindow() && typeof window.siriusVersion === 'string') {
    siriusVersion = window.siriusVersion.split('-')[0];
}
const tinymceENV = env !== 'production' || !isProd ? 'tinymce' : `tinymce-min`;
const eventsOut = (ed) => {
    const eventsMap = {
        MouseEvents: ['mousedown', 'click'],
    };
    Object.keys(eventsMap).forEach(key => {
        const events = eventsMap[key];
        events.forEach(eventName => {
            ed.on(eventName, () => {
                if (document) {
                    const event = document.createEvent(key);
                    event.initEvent(eventName, true, false);
                    document.body.dispatchEvent(event);
                }
            });
        });
    });
};
let LxEditor = React.forwardRef((_a, ref) => {
    var { init = {}, uniqueClass, grammarAction, insertEmojiAction, onEditCreated, aiWriteMailAction, AIWriteContentionShowAction, mouseoverToolbar, mouseoutToolbar, captureScreenAction, previewAction, productImgAction } = _a, rest = __rest(_a, ["init", "uniqueClass", "grammarAction", "insertEmojiAction", "onEditCreated", "aiWriteMailAction", "AIWriteContentionShowAction", "mouseoverToolbar", "mouseoutToolbar", "captureScreenAction", "previewAction", "productImgAction"]);
    const orgToolbar = init.toolbar ||
        `undo redo lxformatpainter removeformat $split fontselect fontsizeselect
  bold italic underline forecolor backcolor $split bullist numlist $split alignleftSplit
  dentSplit lxinputdirection $split lxTable lximg link lxemoji $split preview print code`;
    const [productVersion, setProductVersion] = useState('');
    const [toolbar, setToolbar] = useState(orgToolbar);
    useEffect(() => {
        productAuthApi.doGetProductVersion().then(res => {
            if (res.productVersionId !== 'sirius') {
                setToolbar(pre => {
                    const preStr = JSON.stringify(pre).replace('$split lxgrammar', '');
                    return JSON.parse(preStr);
                });
            }
            setProductVersion(res.productVersionId);
        });
    }, []);
    const config = Object.assign({ tinymceScriptSrc: contextPath + `/${tinymceENV}/tinymce.js?version=${siriusVersion}`, init: Object.assign(Object.assign(Object.assign({}, editorConfig), init), { inEdm, isWeb: !isElectron, grammarAction,
            previewAction,
            productImgAction,
            insertEmojiAction,
            aiWriteMailAction,
            mouseoverToolbar,
            mouseoutToolbar,
            siriusVersion,
            captureScreenAction,
            performanceApi,
            AIWriteContentionShowAction, init_instance_callback: (editor) => {
                eventsOut(editor);
                onEditCreated && onEditCreated(editor);
                init.init_instance_callback && init.init_instance_callback(editor);
            }, toolbar, automatic_uploads: false }) }, rest);
    return (React.createElement("div", { className: uniqueClass }, !!productVersion && (React.createElement(Editor, Object.assign({}, config)))));
});
export const LxEditorForSign = HOCEditorPreview(HOCEditorEmoji(HOCEditorGrammar(HOCToolbarTip(HOCAiWriteMail(HOCCaptureScreen(LxEditor))))));
